/*
* @Author: 王春岩 <Bolt>
* @Date:   2016-12-21 19:24:20
* @Last Modified by:   Bolt
* @Last Modified time: 2016-12-21 19:24:30
*/

'use strict';

import 'jquery-lazyload';

let $ = window.$;

$('img[data-original]').lazyload({
    effect: 'fadeIn'
});



// WEBPACK FOOTER //
// ./src/util/common.js